const Copyright = ({ className = "text-center mt-40 pt-24 border-top border-gray-100" }) => {
  return (
    <div className={className}>
      <p className="text-gray-500 text-sm mb-0">
        ©{new Date().getFullYear()} Fugu's Fresh | All Rights Reserved. Developed by{" "}
        <a
          href="https://codechiptechnologies.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-main-600 hover-text-main-700 fw-medium"
        >
          Codechip Technologies
        </a>
      </p>
    </div>
  );
};

export default Copyright;
